import { useEffect, useMemo, useState } from 'react';
import { RuleApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { P2GBox } from '@parcel2go/core-ui';
import RuleItem from './RuleItem';
import { P2GLink } from '@parcel2go/core-ui';
import RuleCreatePrompt from './RuleCreatePrompt';
import { P2GText } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GButton } from '@parcel2go/core-ui';

interface props {
  item: SmartSendItemApiModel;
  actions: string[];
  rules: RuleApiModel[];
  updateExistingRule: (rule: RuleApiModel, conditions: string[], title: string, description: string) => void;
  toggle: (active: boolean) => void;
}

export default function RuleActionRuleGroup(props: props) {
  const [selectedRule, setSelectedRule] = useState<number>(undefined);
  const [open, setOpen] = useState(false);

  useEffect(() => props.toggle(open), [open]);

  const rulesToShow = useMemo(
    () => props.rules.filter((x) => !selectedRule || x.Id === selectedRule),
    [props.rules, selectedRule]
  );

  const updateExistingRule = (rule: RuleApiModel, conditions: string[], title: string, description: string) => {
    props.updateExistingRule(rule, conditions, title, description);
    setOpen(false);
  };

  if (!open) {
    return (
      <P2GBox p={1} bordered>
        <RuleCreatePrompt
          item={props.item}
          actions={props.actions}
          link={
            <P2GLink variant="body2" onClick={() => setOpen(true)}>
              Manage
            </P2GLink>
          }
        />
      </P2GBox>
    );
  }

  return (
    <>
      <P2GGrid container direction="column" spacing={2}>
        <P2GGrid item>
          <P2GText variant="body2">You have multiple existing rules, which would you like to update?</P2GText>
        </P2GGrid>
        {rulesToShow.map((x) => (
          <P2GGrid item key={x.Id}>
            <RuleItem
              showRuleName={rulesToShow.length > 1}
              actions={props.actions}
              addNewRule={() => {}}
              item={props.item}
              onSelection={(a) => setSelectedRule(a ? x.Id : undefined)}
              updateExistingRule={updateExistingRule}
              rule={x}
            />
          </P2GGrid>
        ))}
        <P2GGrid item>
          <P2GButton variant="primary" onClick={() => setOpen(false)}>
            Back
          </P2GButton>
        </P2GGrid>
      </P2GGrid>
    </>
  );
}
